<template>
  <section v-if="showCookiesModal" class="cookie-banner" aria-label="Настройки cookies">
    <div class="cookie-copy">
      <strong>Пусть всё будет прозрачно.</strong>
      <p>Необходимые настройки помогают сайту работать. Аналитика — только с вашего согласия.</p>
      <NuxtLink to="/privacy">Подробнее о данных</NuxtLink>
    </div>
    <div class="cookie-actions">
      <button class="button button-primary" @click="setCookies(['analytics', 'marketing'])">
        Принять все</button
      ><button class="button button-outline-dark" @click="reject">Только необходимые</button
      ><button
        class="link-button"
        :aria-expanded="settingsOpen"
        @click="settingsOpen = !settingsOpen"
      >
        Настроить
      </button>
    </div>
    <div v-if="settingsOpen" class="cookie-settings">
      <label><input v-model="analytics" type="checkbox" />Аналитика посещений</label
      ><label><input v-model="marketing" type="checkbox" />Маркетинговые cookies</label
      ><button class="button button-dark" @click="saveSettings">Сохранить выбор</button>
    </div>
  </section>
</template>
<script setup lang="ts">
import { useCookies } from '~/core/composables/useCookies';
const { showCookiesModal, setCookies } = useCookies();
const cookie = useCookieSate();
const settingsOpen = ref(false);
const analytics = ref(cookie.allowedCategories.includes('analytics'));
const marketing = ref(cookie.allowedCategories.includes('marketing'));
function reject() {
  cookie.rejectCookies();
  settingsOpen.value = false;
}
function saveSettings() {
  setCookies([
    ...(analytics.value ? ['analytics'] : []),
    ...(marketing.value ? ['marketing'] : []),
  ]);
  settingsOpen.value = false;
}
</script>
